import { getLimitationByUsecaseKey } from '@hooks/useCurrentLimitation';
import { FLOW_ERROR_ANALYSIS_ONLY_DIMENSIONS } from '@src/utils/dimension/appDimensionHelper';
import { metricsStore } from '@globalStore/metricsStore';

function generateFlowDimensions(allDimensions, flowMeta) {
  const flowMetaDimensions = flowMeta?.metaDefinition?.dimensions || [];
  const flowDimensionsMap = flowMetaDimensions.reduce((acc, item) => {
    acc.set(item.identifier, item.category);
    return acc;
  }, new Map<string, string>());

  return allDimensions
    .filter(
      (item) => flowDimensionsMap.has(item.groupBy),
      // && !FLOW_HIDDEN_STATIC_DIMENSIONS.includes(item.groupBy),
    )
    .map((item) => ({ ...item, category: flowDimensionsMap.get(item.groupBy) }));
}

export const getECODimensionList = (
  activeDashboard: Record<string, any> = {},
  dimensions: Record<string, string>[],
) => {
  if (!activeDashboard) return dimensions;
  const { usecaseKey, widgetMeta } = activeDashboard;
  const limitations = getLimitationByUsecaseKey(usecaseKey, widgetMeta?.flowId);
  const dimensionsLimitation = limitations?.dimensions;

  if (dimensionsLimitation) {
    const { excludeCategories = [], excludeTypes = [], excludeKeys = [] } = dimensionsLimitation;

    // This case is only for flow preset,
    // especially need to include dimensions with prefix f_, e_ and nwr_
    if (limitations?.context?.type === 'flow' && limitations?.context?.id) {
      const currentFlowMeta = metricsStore.getState()?.flowConfigMeta?.[limitations?.context?.id];
      return generateFlowDimensions(dimensions, currentFlowMeta);
    }

    return dimensions.filter(
      (it) =>
        !excludeCategories.includes(it.category) &&
        !excludeTypes.includes(it.type) &&
        !excludeKeys.includes(it.field),
    );
  }

  // filter out the flow only dimensions under trends
  return dimensions.filter((it) => !FLOW_ERROR_ANALYSIS_ONLY_DIMENSIONS.includes(it.field));
};
